let WrappedError = require('error/wrapped');

let ActionError = WrappedError({
  message: 'action: {origMessage}',
  type: 'action',
});

export default ActionError;
